import { useEffect, useState } from "react";
import { Image as ImgIcon } from "lucide-react";
import api from "@/lib/api";

/**
 * Read-only thumbnail of an already-uploaded drawing screenshot. Fetches the same
 * blob endpoint the uploader uses (auth via axios instance). Renders nothing until
 * both `entityId` and `path` are present (i.e. a saved entity with a screenshot).
 */
export default function ScreenshotThumb({ scope = "npd", entityId, path, className = "", alt = "Drawing screenshot" }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let revoke;
    if (path && entityId) {
      const ep = scope === "assembly"
        ? `/assemblies/${entityId}/screenshot`
        : `/npd/${entityId}/screenshot`;
      api
        .get(ep, { responseType: "blob" })
        .then((r) => { const b = URL.createObjectURL(r.data); revoke = b; setUrl(b); })
        .catch(() => setUrl(null));
    } else {
      setUrl(null);
    }
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [scope, entityId, path]);

  if (!path || !entityId) return null;

  return (
    <div className={className}>
      {url ? (
        <img
          src={url}
          alt={alt}
          className="w-full h-full object-contain cursor-zoom-in"
          onClick={() => window.open(url, "_blank", "noopener")}
          title="Click to open larger"
        />
      ) : (
        <ImgIcon size={24} className="text-slate-300" />
      )}
    </div>
  );
}
